module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header is-fixed"
  }, [_c('nav-bar', [_c('router-link', {
    staticClass: "home-item nav-item is-tab",
    attrs: {
      "to": {
        name: 'home',
        params: {
          lang: this.$i18n.locale
        }
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.home')))]), _vm._v(" "), _c('router-link', {
    staticClass: "conditions-item nav-item is-tab",
    attrs: {
      "to": {
        name: 'conditions',
        params: {
          lang: this.$i18n.locale
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.conditions')))]), _vm._v(" "), _c('router-link', {
    staticClass: "contact-item nav-item is-tab",
    attrs: {
      "to": {
        name: 'contact',
        params: {
          lang: this.$i18n.locale
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.contact')))]), _vm._v(" "), _c('router-link', {
    staticClass: "blog-item nav-item is-tab",
    attrs: {
      "to": {
        name: 'blog',
        params: {
          lang: this.$i18n.locale
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.blog')))])], 1)], 1), _vm._v(" "), _c('main', [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h5', {
    staticClass: "footer-title"
  }, [_vm._v(_vm._s(_vm.$t('footer.follow')))]), _vm._v(" "), _c('p', {
    staticClass: "social-icons"
  }, [_c('a', {
    staticClass: "social-item",
    attrs: {
      "href": "https://www.facebook.com/Cinenowapp/"
    }
  }, [_c('icon', {
    attrs: {
      "glyph": "facebook-circle",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "social-item",
    attrs: {
      "href": "https://twitter.com/cinenowapp"
    }
  }, [_c('icon', {
    attrs: {
      "glyph": "twitter-circle",
      "color": "primary"
    }
  })], 1)]), _vm._v(" "), _c('nav', {
    staticClass: "navigation level"
  }, [_c('p', {
    staticClass: "level-item has-text-centered"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        params: {
          lang: this.$i18n.locale
        }
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.home')))])], 1), _vm._v(" "), _c('p', {
    staticClass: "level-item has-text-centered"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'conditions',
        params: {
          lang: this.$i18n.locale
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.conditions')))])], 1), _vm._v(" "), _c('p', {
    staticClass: "level-item has-text-centered"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact',
        params: {
          lang: this.$i18n.locale
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.contact')))])], 1), _vm._v(" "), _c('p', {
    staticClass: "level-item has-text-centered"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'blog',
        params: {
          lang: this.$i18n.locale
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.blog')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('footer.copyright'))
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-682da0b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 118
// module chunks = 0